'use client'

import Link from 'next/link'
import { useEffect, useState } from 'react'
import { clsx } from 'clsx'
import SHIPPING_DATA from '../shipping.json'

interface ShippingDataType {
  title: string
  id: string
}

const sections = SHIPPING_DATA.map((item: ShippingDataType) => ({
  id: item.id,
  label: item.title,
}))

const Title = () => {
  const [activeSection, setActiveSection] = useState('')

  useEffect(() => {
    // 初期表示時のハッシュを設定
    const initialHash = window.location.hash.replace('#', '')
    if (initialHash) {
      setActiveSection(initialHash)
    }

    // スクロールイベントリスナー
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 150

      // 各セクションの位置を確認して、現在のスクロール位置に最も近いセクションを特定
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i].id)
        if (section && section.offsetTop <= scrollPosition) {
          setActiveSection(sections[i].id)
          // URLのハッシュも更新（ブラウザ履歴には追加しない）
          window.history.replaceState(null, '', `#${sections[i].id}`)
          break
        }
      }
    }

    // 初回実行
    handleScroll()

    // スクロールイベントを登録
    window.addEventListener('scroll', handleScroll)

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return (
    <div className="flex flex-col text-[12px] font-normal text-[#a8a8a8]">
      {sections.map((section, index) => {
        const isActive = section.id === activeSection

        return (
          <div className="leading-7 hover:cursor-pointer" key={index}>
            <Link
              onClick={() => setActiveSection(section.id)}
              href={`/shipping/#${section.id}`}
              className={clsx(isActive && 'text-[#000000]')}
            >
              {section.label}
            </Link>
          </div>
        )
      })}
    </div>
  )
}

export default Title
